<ng-content *ngIf="!hasErrors && props?.rendered"></ng-content>